import { render, staticRenderFns } from "./background_questions_sinp.vue?vue&type=template&id=fa765436&"
import script from "./background_questions_sinp.vue?vue&type=script&lang=js&"
export * from "./background_questions_sinp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports